var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyInsight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05 13.275L3 12.225L10.275 4.95001L14.025 8.70001L19.5 3.22501L20.55 4.27501L14.025 10.8L10.275 7.05001L4.05 13.275Z",
    fill: "#C3C3C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7749 6.75H19.2749V4.5H17.0249V3H20.7749V6.75Z",
    fill: "#C3C3C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7749 19.5H3.5249V21H20.7749V19.5Z",
    fill: "#C3C3C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2749 20.25H5.7749V15.75H5.0249V20.25H3.5249V14.25H7.2749V20.25Z",
    fill: "#C3C3C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7749 20.25H10.2749V12H9.5249V20.25H8.0249V10.5H11.7749V20.25Z",
    fill: "#C3C3C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7749 20.25H19.2749V12H18.5249V20.25H17.0249V10.5H20.7749V20.25Z",
    fill: "#C3C3C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2749 20.25H14.7749V14.25H14.0249V20.25H12.5249V12.75H16.2749V20.25Z",
    fill: "#C3C3C3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyInsight);
export default __webpack_public_path__ + "static/media/greyInsight.ceb1e368d328b4247278391690f32cf6.svg";
export { ForwardRef as ReactComponent };